module.exports = __webpack_public_path__ + "static/media/img-filter.f8242247.svg";